export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  USER = 'ROLE_USER',
  MARKETER = 'ROLE_MARKETER',
  GROUP = 'ROLE_GROUP',
  API = 'ROLE_API',
  EXTERNAL_MARKETER = 'ROLE_EXTERNAL_MARKETER',
}
